// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_1APV27","card":"_11Lj5A","cardHeading":"_15M-Wf","cartTitle":"_38ZWjS","cardSubtitle":"_19O6fL","cardIcon":"_1da9nl"};